import { WithdrawProperty } from '@akiba/models_beta_temp';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-company-withdraw-modal',
  templateUrl: './create-company-withdraw-modal.component.html',
  styleUrls: ['./create-company-withdraw-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateCompanyWithdrawModalComponent implements OnInit {

  withdraw: WithdrawProperty = new WithdrawProperty();
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  procType(): void {

    const date = new Date();
    this.withdraw = new WithdrawProperty();
    this.withdraw.withdrawPropertyID = date.getTime().toString();

  }

  createdParameter(): void {
    this.activeModal.close(this.withdraw);
  }

}
